import type { ElementViewTemplate } from "@microsoft/fast-element";
import { elements, html, ref, slotted, when } from "@microsoft/fast-element";
import { NatGenDialog } from './dialog';


export function dialogTemplate<T extends NatGenDialog>(): ElementViewTemplate<T> {
    return html<T>`
        <div
            role="dialog"
            tabindex="-1"
            class="control"
            part="control"
            aria-modal="${x => x.modal}"
            aria-describedby="content"
            aria-labelledby="${x => x.ariaLabelledby}"
            aria-label="${x => x.ariaLabel}"
            ${ref("dialog")}
        >
            <div class="title" part="title">
                <slot name="title" ${slotted({ property: 'slottedTitleNodes', filter: elements() })}></slot>
                <natgen-button variant="link-light" class="close-button" part="close-button" @click="${x => x.dismiss()}">
                    <natgen-icon name="light/times"></natgen-icon>
                </natgen-button>
            </div>
            <div ${ref('content')} id="content" class="content" part="content">
                <slot></slot>
            </div>
            <div
                class="actions"
                part="actions"
            >
                <slot name="actions" ${slotted({ property: 'slottedActionNodes', filter: elements() })}></slot>
            </div>
        </div>
`};

export function modalTemplate<T extends NatGenDialog>(): ElementViewTemplate<T> {
return html<T>`
    <div class="positioning-region" part="positioning-region">
        ${when(
            x => x.modal,
            html<NatGenDialog>`
                <div
                    class="overlay"
                    part="overlay"
                    role="presentation"
                ></div>
            `
        )}
        ${dialogTemplate()}
    </div>
`};
